import React from 'react';
import GridCard from './_GridCard';
import { AccProps } from './_AccessorySlider';
import { appConfig } from '../../utils/appConfig';
import { useIsMobile } from '../../utils/useMediaQuery';
import { classNames } from '@repo/ui/src/utils/classNames';

interface AccGridProps extends AccProps {
  reverse?: boolean;
  accessories: any;
}

const AccGrid = ({ accessories, reverse }: AccGridProps) => {
  const isMobile = useIsMobile();
  const isMeaterMobile = appConfig.isMeater && isMobile;

  return (
    accessories && (
      <div className='tw-px-6 md:tw-px-12 tw-mx-auto tw-w-fit '>
        <ul className={classNames('tw-list-none tw-max-w-[1680px]',
          appConfig.isMeater
            ? 'tw-grid tw-grid-cols-1 tw-gap-6 sm:tw-grid sm:tw-gap-[1.6666vw] sm:tw-grid-cols-3 md:tw-grid-cols-3 lg:tw-grid-cols-4'
            : 'tw-flex tw-gap-[1.6666vw] sm:tw-grid sm:tw-grid-cols-3 md:tw-grid-cols-3 lg:tw-grid-cols-4'
    )}>
          {accessories.map((accessory: any, i: any) => (
            <GridCard {...accessory} key={i} reverse={reverse} isMeaterMobile={isMeaterMobile} />
          ))}
        </ul>
      </div>
    )
  );
};

export default AccGrid;
